import { get } from '../ReaderlyHttpClient';

export interface IBaseEntity {
  id: number;
  name: string;
}

export abstract class ServiceBase<T extends IBaseEntity> {
  private resourceRoute: string;

  constructor(resourceRoute: string) {
    this.resourceRoute = resourceRoute;
  }

  public async GetAll(): Promise<T[]> {
    return await get<T[]>(this.resourceRoute);
  }
}